import * as React from 'react';
import { useSelector } from 'react-redux';
import { CollapsedList } from '../../components/BuildersMobile/CollapsedList';
import { BuilderCard, Builders, ToggleButton } from '../../components/BuildersMobile';
import { buildersSelector } from '../../selectors';

const VISIBLE_BUILDERS_LENGTH = 3;

export function BuildersContainer() {
  const builders = useSelector(buildersSelector);
  const [isOpened, setOpenedState] = React.useState(false);
  const onToggleClick = React.useCallback(() => setOpenedState(!isOpened), [isOpened, setOpenedState]);

  const visibleElementsLength = isOpened ? builders.length : builders.slice(0, VISIBLE_BUILDERS_LENGTH).length;
  const hiddenElementsLength = builders.length - visibleElementsLength;
  const shouldShowButton = builders.length - VISIBLE_BUILDERS_LENGTH > 0;

  const togglerText = isOpened ? 'Свернуть' : `Показать ещё ${hiddenElementsLength}`;

  if (!builders.length) {
    return null;
  }

  return (
    <Builders
      list={
        <CollapsedList isOpened={isOpened} visibleRows={VISIBLE_BUILDERS_LENGTH}>
          {builders.map((item, index) => (
            <BuilderCard
              key={item.id || index}
              name={item.name}
              logoUrl={item.logoUrl}
              website={item.website}
              stats={item.stats}
            />
          ))}
        </CollapsedList>
      }
      toggle={
        shouldShowButton && (
          <ToggleButton isOpened={isOpened} onClick={onToggleClick}>
            {togglerText}
          </ToggleButton>
        )
      }
    />
  );
}
